module.exports = __webpack_public_path__ + "img/a8a3ecf0dab764054ba9a72436a490e2.png";